var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg19266",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 270.9342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs19263"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29474"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929292",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop29470"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9a",
      stopOpacity: 1
    },
    offset: 0.20418006,
    id: "stop29478"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848484",
      stopOpacity: 1
    },
    offset: 0.39951769,
    id: "stop29480"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#727272",
      stopOpacity: 1
    },
    offset: 0.60168809,
    id: "stop29482"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#606060",
      stopOpacity: 1
    },
    offset: 0.79602093,
    id: "stop29484"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2b2b2b",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop29472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29458"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acacac",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop29454"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#626262",
      stopOpacity: 1
    },
    offset: 0.20096463,
    id: "stop29462"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#575757",
      stopOpacity: 1
    },
    offset: 0.40000001,
    id: "stop29464"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#676767",
      stopOpacity: 1
    },
    offset: 0.60490352,
    id: "stop29466"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b0b0",
      stopOpacity: 1
    },
    offset: 0.79923636,
    id: "stop29468"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adadad",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop29456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29442"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbdbd",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop29438"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a8a8",
      stopOpacity: 1
    },
    offset: 0.2,
    id: "stop29446"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8c8c",
      stopOpacity: 1
    },
    offset: 0.39951771,
    id: "stop29448"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5b5b5b",
      stopOpacity: 1
    },
    offset: 0.60490352,
    id: "stop29450"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#606060",
      stopOpacity: 1
    },
    offset: 0.79923636,
    id: "stop29452"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "silver",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop29440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient28700"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9634e",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop28696"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f14a2c",
      stopOpacity: 1
    },
    offset: 0.2,
    id: "stop28704"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e34424",
      stopOpacity: 1
    },
    offset: 0.40000001,
    id: "stop28706"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ef4f32",
      stopOpacity: 0.98113215
    },
    offset: 0.60000002,
    id: "stop28708"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f68a74",
      stopOpacity: 1
    },
    offset: 0.79923636,
    id: "stop28710"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff2525",
      stopOpacity: 0.93081754
    },
    offset: 1,
    id: "stop28698"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314",
    id: "linearGradient31318",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.1361 0 0 1.4645 -1081.2047 21.842977)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient31314"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b3b3",
      stopOpacity: 1
    },
    offset: 0.07717042,
    id: "stop31302"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d2",
      stopOpacity: 1
    },
    offset: 0.24919616,
    id: "stop31304"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9c9c",
      stopOpacity: 1
    },
    offset: 0.40956593,
    id: "stop31306"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afafaf",
      stopOpacity: 1
    },
    offset: 0.61816716,
    id: "stop31308"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d0",
      stopOpacity: 1
    },
    offset: 0.77893889,
    id: "stop31310"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#989898",
      stopOpacity: 1
    },
    offset: 0.95498395,
    id: "stop31312"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314",
    id: "linearGradient30439",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.1005 0 0 10.55184 -618.98525 -1800.5955)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient28700",
    id: "linearGradient28702",
    x1: 26.192024,
    y1: 39.753902,
    x2: 51.866421,
    y2: 55.489822,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.55267 0 0 6.55267 -87.883269 -199.74487)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient29442",
    id: "linearGradient29444",
    x1: 40.405777,
    y1: 21.268559,
    x2: 73.111427,
    y2: 22.554464,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.79243 3.33626 -3.20464 5.8193 -92.990687 -203.31933)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient29458",
    id: "linearGradient29460",
    x1: 27.744911,
    y1: 40.582108,
    x2: 50.417057,
    y2: 55.282772,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.55267 0 0 6.55267 -87.883269 -199.74487)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient29474",
    id: "linearGradient29476",
    x1: 39.132748,
    y1: 42.031471,
    x2: 38.718643,
    y2: 54.55809,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.55267 0 0 6.55267 -87.883269 -199.74487)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "salt",
    transform: "translate(-15.827212 -44.607552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30437",
    style: {
      fill: "url(#linearGradient30439)",
      fillOpacity: 1,
      strokeWidth: 6.9419
    },
    d: "M82.201455 51.472893c-.08649.0498-.160147.119193-.240417.179609-.419109.296246-.84688.590985-1.317231.783195-1.081144.547934-.876079.444532-.755117.384379v.0036c.108382-.05438.223709-.109757.257325-.125746-.03342.01835-.115197.0616-.267481.140096.005-.0066.0057-.0085.0105-.01442-.06559.03277-.114672.05766-.179477.08983h-.0037c-.394602.352534-1.119642 1.066592-.639999.502983-.557763.497937-1.253545.908383-1.273204.912531-.48909.363608-.738328.544527-.890566.653825-.648911.616017-1.339687 1.157274-2.08928 1.631065-.25575.147893-.686647.516875-.900724.729312-.0557.04586-.09796.07975-.142192.114999-.07385.101766-.211258.27305-.460522.556911-.258044.288187-.506194.584171-.748348.887383-.08459.09476-.162834.196252-.253981.283796-.03473.03342-.057.05374-.08807.08269-.0085.01114-.0118.01769-.02031.02817-.08047.117555-.24638.363804-.325079.467074-.0078.0105-.02425.03341-.03407.04652-.03735.07942-.08191.153201-.132036.204836-.209882.358628-.396371.597866-.545183.793975-.290611.603304-.754493 1.522473-.819456 1.534064-.05963.09206-.119652.184458-.179478.276654V267.89751l-.03539 4.48023c-.355679 1.47104.0629-1.53065.03539-.0505-.01179 23.86403 41.773831 43.21257 93.323271 43.21248 51.54945.00009 93.33526-19.34845 93.32329-43.21248-.0321-1.48028-.22902-2.95881-.58923-4.42974l.69105 4.27659-.10183-108.99472c-1.27785-.87269-2.56439-1.76693-3.76544-2.73763.45135.1661.26924.0722-.73819-.57127-.19166-.1089-.38668-.21564-.57906-.32337-1.33664-.82829-2.19263-1.39049-4.02956-2.66935-.97695-.64543-1.88311-1.38051-2.92229-1.91848-1.53827-.85298-3.06774-1.72173-4.62552-2.53641-1.89352-1.04898-3.82717-2.02893-5.66508-3.1831-1.50539-.86084-3.01904-1.69145-4.53073-2.5328-1.26288-.77287-2.60835-1.39403-3.90087-2.10889-2.34604-1.12225-4.68688-2.24695-6.9857-3.47409-2.17162-1.30278-4.38764-2.53067-6.49471-3.94834-2.22347-1.35561-4.52478-2.55519-6.72497-3.95551-1.91872-1.28758-3.93134-2.41929-5.8581-3.69685-2.15437-1.36873-4.28225-2.77999-6.41995-4.17822-2.06363-1.59151-4.21026-3.05649-6.30169-4.60578-1.49874-1.09131-2.97754-2.2005-4.51379-3.2298-1.42561-1.08816-2.886-2.1225-4.3614-3.1328-.81427-.70383-1.76288-1.20838-2.66155-1.77477-.88309-.47675-2.5843-1.3588-4.09728-2.32805-1.36476-.65851-2.55966-1.69988-3.84671-2.50049-1.8872-1.22128-3.75857-2.45855-5.63461-3.70043-1.54676-1.00459-3.12142-1.96105-4.67294-2.95676-1.8469-1.223892-3.63634-2.527812-5.38742-3.901632-1.16801-.88796-2.23673-1.89678-3.53518-2.58671-1.65927-1.16274-3.3056-2.3446-4.92352-3.5711-1.61111-1.18325-3.26056-2.30923-4.88626-3.47051-2.36982-1.54431-4.67416-3.20374-7.06697-4.70997-2.97146-1.98793-5.95249-3.9573-8.91921-5.95303-3.52924-2.27045-7.14157-4.39365-10.63601-6.72546-3.98723-2.668574-7.97412-5.344409-12.159807-7.655961-4.00365-2.262631-7.86571-4.776189-11.797454-7.174538-1.887693-1.254405-3.752347-2.547082-5.607525-3.854923-.199529.09043-.364657.139441-.453773.107726-.01835.002-.03931.0051-.05766.0072.04325-.02228.08879-.04587.132036-.06815.313217-.249854-.209095.132625-.121879.03604.04259-.04718.195924-.153463.142192-.122141zM79.70922 52.91355c-.05438.02687.208375-.107792.179478-.09344.112574-.155364.000563-.06743-.179478.09344z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31294",
    style: {
      fill: "url(#linearGradient31318)",
      fillOpacity: 1,
      strokeWidth: 3.26633
    },
    d: "M166.96282 271.2626a148.86506 5.9960738 0 0 0-147.944372 5.38067h-.918187v32.28605h.918187a148.86506 5.9960738 0 0 0-.918187.61463 148.86506 5.9960738 0 0 0 148.863499 5.9978 148.86506 5.9960738 0 0 0 148.86344-5.9978 148.86506 5.9960738 0 0 0-.93699-.61463h.93699v-32.28605h-.93699a148.86506 5.9960738 0 0 0-147.92705-5.38067Zm-151.135608 5.99544 2.272158 32.59598z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24268",
    style: {
      fill: "url(#linearGradient29444)",
      fillOpacity: 1,
      strokeWidth: 2.55978,
      strokeDasharray: "1.27989,1.27989"
    },
    d: "M98.624373 44.642777a107.26897 43.779073 30.160372 0 0-27.402282 12.287356 107.26897 43.779073 30.160372 0 0 71.826639 91.893217 107.26897 43.779073 30.160372 0 0 114.07514 15.1769 107.26897 43.779073 30.160372 0 0-71.82663-91.893242 107.26897 43.779073 30.160372 0 0-86.672867-27.464231Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25060",
    style: {
      fill: "url(#linearGradient28702)",
      fillOpacity: 1,
      strokeWidth: 2.29338,
      strokeDasharray: "1.1467,1.1467"
    },
    d: "M104.41519 50.930089A96.082592 39.232414 30.194104 0 0 79.876496 61.94404a96.082592 39.232414 30.194104 0 0 64.320584 82.36983 96.082592 39.232414 30.194104 0 0 102.15401 13.60402 96.082592 39.232414 30.194104 0 0-64.32057-82.369832 96.082592 39.232414 30.194104 0 0-77.61533-24.617969Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25788",
    style: {
      fill: "url(#linearGradient29460)",
      fillOpacity: 1,
      strokeWidth: 2.06945,
      strokeDasharray: "1.03473,1.03473"
    },
    d: "M113.19304 57.71089a86.434966 35.510777 30.6369 0 0-22.003498 10.001444 86.434966 35.510777 30.6369 0 0 57.675388 74.797576 86.434966 35.510777 30.6369 0 0 91.60008 12.35341 86.434966 35.510777 30.6369 0 0-57.67536-74.797582 86.434966 35.510777 30.6369 0 0-69.59661-22.354848Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27968",
    style: {
      fill: "url(#linearGradient29476)",
      fillOpacity: 1,
      strokeWidth: 1.85724,
      strokeDasharray: ".928625,.928625"
    },
    d: "M118.32445 63.134771a77.783889 31.782524 30.2427 0 0-19.858357 8.925657 77.783889 31.782524 30.2427 0 0 52.052527 66.752062 77.783889 31.782524 30.2427 0 0 82.66984 11.02463 77.783889 31.782524 30.2427 0 0-52.0525-66.752082 77.783889 31.782524 30.2427 0 0-62.81151-19.950267z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalt);
export default __webpack_public_path__ + "static/media/salt.3171c80d02ea2d78da949a40fe4c9305.svg";
export { ForwardRef as ReactComponent };